import Vue from "vue";
import Vuex from "vuex";
import Token from 'utils/token';
// import createPersistedState from "vuex-persistedstate";
import { getPublicKey, getAmountInfo,getMemberInfo } from "api/user.js";
import {
  domainQuery,
  domainTypeList,
  getDomainSuffix,
  getRegionList,
  sensitiveWords
} from "api/domain.js";

Vue.use(Vuex);

// 域名筛选字典兜底数据
// 网关 /hkweb/dn/cxtj、/hkweb/dn/gc 偶发 hang（nginx 502）或未登录态不可用，
// 此时用这份内置数据保证首页/筛选下拉仍可渲染，不至于整页白屏。
const FALLBACK_DOMAIN_QUERY = {
  domainSufNameList: [
    ".cn", ".com.cn", ".net.cn", ".org.cn", ".com", ".cc",
    ".net", ".top", ".vip", ".club", ".org", ".中国",
  ],
  domainTypeList: [],
  domainConstructionList: [],
  domainTraitList: ["高年龄", "备案"],
  domainLenList: ["1", "2", "3", "4", "5", "6", "7", "8", "8以上"],
  registeredAtList: Array.from({ length: 20 }, (_, i) => {
    const y = 2025 - i;
    return { name: `${y}年之前`, value: `${y}-01-01` };
  }),
  domainSuffix: [],
  sensitiveWords: [],
};

export default new Vuex.Store({
  // plugins: [createPersistedState()],
  state: {
    publicKey: "",
    prevRouter: {
      name: "index",
      path: "/",
      query: {},
      params: {},
    },
    token: "",
    expiration: 0,
    expiresIn: 0,
    refreshToken: "",
    tokenType: "",
    user: "",
    freezeAmount: 0, // 冻结金额
    balance: 0, // 可用余额
    domainQueryData: {
      // 域名构造
      domainSufNameList: FALLBACK_DOMAIN_QUERY.domainSufNameList,
      // 域名品类
      domainTypeList: [],
      // 域名构造
      domainConstructionList: [],
      // 域名特征
      domainTraitList: FALLBACK_DOMAIN_QUERY.domainTraitList,
      // 域名长度
      domainLenList: FALLBACK_DOMAIN_QUERY.domainLenList,
      // 注册日期
      registeredAtList: FALLBACK_DOMAIN_QUERY.registeredAtList,
      // 域名后缀
      domainSuffix: [],
      // 敏感词
      sensitiveWords: [],
    },
    // 复制模板数据
    templateCopy: {},
    areas: [], // 省市区
    countries: [], // 国家
    routeParamsList: [], // 跳转路由参数
    navStatus: false, // 导航栏状态
    searchData: [], // 搜索数据
  },
  mutations: {
    MUT_NAV_STATUS(state, data) {
      state.navStatus = data;
    },
    MUT_PUBLIC_KEY(state, data) {
      state.publicKey = data;
    },
    MUT_TOKEN_INFO(state, data) {
      if (data != null) {
        state.token = data.accessToken || "";
        state.expiration = data.expiration || "";
        state.expiresIn = data.expiresIn || "";
        state.refreshToken = data.refreshToken || "";
        state.tokenType = data.tokenType || "";
        Token.set(data)
      } else {
        Token.remove();
      }
    },
    MUT_LOGOUT(state) {
      state.token = "";
      state.expiration = "";
      state.expiresIn = "";
      state.refreshToken = "";
      Token.remove();
    },
    MUT_ROUTE(state, data) {
      state.prevRouter.name = data.name;
      state.prevRouter.params = data.params;
      state.prevRouter.path = data.path;
      state.prevRouter.query = data.query;
    },
    MUT_AMOUNT(state, data) {
      state.balance = data.rest; // 余额
      state.freezeAmount = data.frozen; // 冻结金额
    },
    MUT_BALANCE(state, data) {
      state.balance = data;
    },
    MUT_USER_INFO(state, data) {
      state.user = data;
    },
    MUT_USER_INFO_USERNAME(state, data) {
      state.user.username = data;
    },
    MUT_USER_INFO_PHONENUMBER(state, data) {
      state.user.phoneNumber = data;
    },
    MUT_USER_INFO_EMAIL(state, data) {
      state.user.email = data;
    },
    MUT_USER_INFO_COMPANY(state, data) {
      state.user.company = data;
    },
    MUT_USER_PART_INFO(state, data) {
      state.user.nick = data.nick;
      state.user.sex = data.sex;
      state.user.birthday = data.birthday;
      state.user.qqNum = data.qq;
      state.user.wechatNum = data.wechat;
      state.user.province = data.province;
      state.user.city = data.city;
      state.user.region = data.region;
      state.user.addr = data.addr;
      state.user.postcode = data.postcode;
      state.user.fax = data.fax;
      state.user.wechatImg = data.img;
    },
    MUT_DOMAIN_QUERY(state, data) {
      state.domainQueryData.domainSufNameList = data.nameList;
      state.domainQueryData.domainConstructionList =
        data.struList;
      state.domainQueryData.domainTraitList = data.featureList;
      state.domainQueryData.domainLenList = data.llist;
      state.domainQueryData.registeredAtList = data.regTimeList;
    },
    MUT_DOMAIN_TYPELIST(state, data) {
      state.domainQueryData.domainTypeList = data;
    },
    MUT_DOMAIN_SUFFIX(state, data) {
      state.domainQueryData.domainSuffix = data;
    },
    MUT_SENSITIVE_WORDS(state, data) {
      state.domainQueryData.sensitiveWords = data;
    },
    // 复制模板数据
    MUT_DOMAIN_TEMPLATECOPY(state, data) {
      state.templateCopy = data;
    },
    MTU_REGION_LIST(state, data) {
      state.countries = data.countryList;
      state.areas = data.distList;
    },
    // 路由跳转需要的参数
    MTU_ROUTE_PARAMS_LIST(state, data) {
      state.routeParamsList = data;
    },
    MTU_SEARCH_DATA(state, data) {
      state.searchData = data;
    },
  },
  actions: {
    ACT_PUBLIC_KEY({ commit }) {
      getPublicKey()
        .then((res) => {
          if (res.code === 200 && res.result) {
            commit("MUT_PUBLIC_KEY", res.data);
          }
        })
        .catch(() => {});
    },
    ACT_USER_INFO({ commit }){
      getMemberInfo()
        .then((res) => {
          if (res.code === 200 && res.result) {
            commit("MUT_USER_INFO", res.data);
          }
        })
        .catch(() => {});
    },
    ACT_DOMAIN_QUERY({ commit, state }) {
      // /hkweb/dn/cxtj、/hkweb/dn/gc 需要登录态，网关对匿名请求会挂死（502），
      // 故无 token 时不发起；已登录时正常请求，失败则保留内置兜底字典。
      const hasToken = !!state.token;
      if (hasToken) {
        domainQuery()
          .then((res) => {
            if (res.code === 200 && res.result) {
              commit("MUT_DOMAIN_QUERY", res.data);
            }
          })
          .catch(() => {});
        domainTypeList()
          .then((res) => {
            if (res.code === 200 && res.result) {
              const temp = res.data.map((o) => {
                let children = o.typeChildrenList.map((o2) => {
                  return { label: o2.label, value: o2.value };
                });
                return { label: o.type, value: o.typeValue, children };
              });
              commit("MUT_DOMAIN_TYPELIST", temp);
            }
          })
          .catch(() => {});
      }
      getDomainSuffix()
        .then((res) => {
          if (res.code === 200 && res.result) {
            const datas = res.data.map(o => {
              return {
                domainSufName: o.houzhui,
                isCheck: o.sel
              }
            })
            commit("MUT_DOMAIN_SUFFIX", datas);
          }
        })
        .catch(() => {});
      sensitiveWords()
        .then((res) => {
          if (res.code === 200 && res.result) {
            commit("MUT_SENSITIVE_WORDS", res.data);
          }
        })
        .catch(() => {});
    },
    ACT_REGION_LIST({ commit }) {
      getRegionList().then((res) => {
        const { code, data } = res;
        if (code === 200) {
          commit("MTU_REGION_LIST", data);
        }
      });
    },
    // 获取账户金额
    ACT_AMOUNT_INFO({ commit }) {
      getAmountInfo().then((res) => {
        const { code, data } = res;
        if (code === 200) {
          commit("MUT_AMOUNT", data);
        }
      });
    },
  },
  modules: {},
});
